import { Injectable } from "@angular/core";
import { GeneralDetailsStore } from "../../store/general-details";
import { map, Observable, of } from "rxjs";
import { MCFormisForm, MCResponse, MCUnionRequestHttpWrapperService, MC_RESPONSE_STATUS_CODE, MCSectionSchema } from "@maslul/common-services";
import { FieldsMapperService } from "../../fields/mapper";
import { FormlyFieldConfig } from "@ngx-formly/core";
import cloneDeep from "clone-deep";
import { FieldsFormStateService } from "../../fields/form-state";
import { RequestApprovalTypeDetailsStore } from "../../store/approval-type-details-store";

@Injectable({ providedIn: 'root' })
export class GeneralDetailsService {

    constructor(
        private generalDetailsStore: GeneralDetailsStore,
        private formStateService: FieldsFormStateService,
        private fieldsMapperService: FieldsMapperService,
        private httpWrapperService: MCUnionRequestHttpWrapperService<any>,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore

    ) {

    }

    getGeneralDetailsFields(approvalTypeIds: Array<number>) {
        return this.httpWrapperService.getFieldsByTab("fields-general", approvalTypeIds);

    }


    getFields(formisForm: MCFormisForm): Observable<Array<FormlyFieldConfig> | undefined> {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId

        try {
            const snapshot = this.generalDetailsStore.getSnapshot();
            const storedSchemas = snapshot.fieldsSchema;

            if (storedSchemas && Array.isArray(storedSchemas) && storedSchemas.length > 0) {
                console.log('Generating fresh fields from stored schemas...');

                const freshFields = this.fieldsMapperService.generateSchema(storedSchemas, formisForm);

                return of(freshFields);
            }

            else {
                return this.getGeneralDetailsFields([parseInt(approvalTypeId)])//until npm work
                    .pipe(map((res: MCResponse) => {
                        if (res && res.code === MC_RESPONSE_STATUS_CODE.SUCCESS) {
                            const schemas: Array<MCSectionSchema> = res.data as Array<MCSectionSchema>;
                            const generatedSchema: Array<FormlyFieldConfig> = this.fieldsMapperService.generateSchema(schemas, formisForm);
                            this.generalDetailsStore.setFieldsSchema(cloneDeep(schemas));
                            this.generalDetailsStore.setFormisFormFields(cloneDeep(generatedSchema));
                            return generatedSchema;
                        }
                        else {
                            throw new Error(res.data)

                        }
                    }));
            }
        }
        catch (ex) {
            console.error('getGeneralDetailsFields', ex);
            return of(undefined)
        }
    }


    saveFormState(model: any) {
        if (model.communicationAdjastmentSection) {
            this.formStateService.setFormState('billOfLadingOrSupplierInvoice', model.communicationAdjastmentSection.billOfLadingOrSupplierInvoice);
        }
    }
}